import React from "react";
import TableOfContents from "../../TableOfContents/TableOfContents.tsx";
import TocMobile from "../../ToCTelephone/TocTelephone.tsx";
// import the corresponding css file
import "./HGTNotebook.css";
// import the separated file related to the component
import TextHGTNotebook from "./TextHGTNotebook.jsx";

const HGTNotebook = () => {
  // headingData is used in the TableOfContents
  // every title (h2, h3, etc) used in the separated file of the component should be in the table
  const headingsData = [
    {
      // the level 2 is the most important level you can have (the basic one)
      level: 2,
      // the text will be displayed in the table of contents
      text: "pGLO",
      // the id should be the same as the one used in the separated file of the component else the name of the title would not be displayed as wanted
      // do not use space for the id
      id: "Intro-EC20",
    },
    {
      level: 2,
      text: "Transformation of pGLO plasmid into DH5α",
      id: "Transformation-EC20",
    },
    {
      level: 2,
      text: "Primary Culture of transformed DH5α bacteria with pGLO plasmid",
      id: "PrimaryCulture-pGLO",
    },
    {
      // level 3 has a specific style so the title in the TOC will be display on the right of a level 2 title
      level: 2,
      text: "Secondary Culture of transformed DH5α bacteria with pGLO plasmid",
      id: "SecondaryCulture-pGLO",
    },
    {
      level: 2,
      text: "Extract pGLO from DH5α",
      id: "Mini-prep",
    },
    {
      level: 2,
      text: "Transformation of pGLO plasmid into CJ236",
      id: "Transformation-EC2",
    },

    {
      level: 2,
      text: "Primary Culture of transformed CJ236 bacteria with pGLO plasmid",
      id: "PrimaryCulture-pGLO",
    },
    {
      level: 2,
      text: "Secondary Culture of transformed CJ236 bacteria with pGLO plasmid",
      id: "SecondaryCulture-pGLO",
    },
    {
      level: 2,
      text: "Speed-up Uracilation (20 min) of CJ236 bacteria with pGLO plasmid",
      id: "Speed-up Uracilation 20",
    },
    {
      level: 2,
      text: "Immediately extract UpGLO (20 min) from CJ236",
      id: "Mini-prep 20",
    },
    {
      level: 2,
      text: "Speed-up Uracilation (30 min) of CJ236 bacteria with pGLO plasmid",
      id: "Speed-up Uracilation 30",
    },
    {
      level: 2,
      text: "Immediately extract UpGLO (30 min) from CJ236",
      id: "Mini-prep 30",
    },
    {
      level: 2,
      text: "Transformation of UpGLO plasmid (20 min) into BL21 and CJ236",
      id: "Transformation UpGLO",
    },
    {
      level: 2,
      text: "Transformation of UpGLO plasmid (30 min) into BL21, DH5α and CJ236",
      id: "Transformation UpGLO 30",
    },
    {
      level: 2,
      text: "Transformation of pGLO plasmid into DH5α",
      id: "Transformation-EC20DH",
    },
    {
      level: 2,
      text: "Primary Culture of transformed DH5α bacteria with pGLO plasmid",
      id: "PrimaryCulture-pGLODH",
    },
    {
      level: 2,
      text: "Secondary Culture of transformed DH5α bacteria with pGLO plasmid",
      id: "SecondaryCulture-pGLODH",
    },
    {
      level: 2,
      text: "Speed-up Uracilation (30 min) of DH5α bacteria with pGLO plasmid",
      id: "Speed-up Uracilation30.2",
    },
    {
      level: 2,
      text: "Immediately extract pGLO (30 min) from DH5α",
      id: "Mini-prep30.22",
    },
   
  ];

  return (
    <>
      {/* Display the content of the page on the entire viewport */}
      <div>
        {/* divide the section in columns */}
        <div className="grid grid-cols-12 gap-4" style={{ marginLeft: "50px" }}>
          {/* section on the left (=Table of content) */}
          <div className="hidden md:block col-span-4 ml-6 order-2 md:order-1">
            {/* it will stay visible on the viewport */}
            <div className="sticky top-4 scrollable">
              {/* call the Table of contents with headingData modified above */}
              <TableOfContents headings={headingsData} />
            </div>
          </div>
          {/* main content which is a separated file you call and it is displayed on the right of the section above */}
          <main className="prose col-span-12 md:col-span-8 order-1 md:order-2">
            <TextHGTNotebook />
          </main>
          {/* display the table of content when the viewport is too small */}
          <div className="md:hidden col-span-12 order-3 TOCstyle">
            <TocMobile headings={headingsData} />
          </div>
        </div>
      </div>
    </>
  );
};

// don't forget to change the name of the component you're exporting
export default HGTNotebook;
